// GA4 のイベントパラメータ値は100文字までで、超過分は切り捨てられる。
// GMC の商品タイトルは最大150文字あるため、storeeel_name に載せる前にここで丸める。
// truncateUrlForQuery は「エンコード後長6000文字」基準の current_url 専用なので基準が異なる。
export const GA4_EVENT_PARAM_VALUE_MAX_LENGTH = 100;

export const truncateEventParamValue = (value, maxLength = GA4_EVENT_PARAM_VALUE_MAX_LENGTH) => {
  if (typeof value !== 'string') return value;
  if (value.length <= maxLength) return value;

  const sliced = value.slice(0, maxLength);
  // サロゲートペアの途中で切ると文字化けするため、末尾が上位サロゲート単独ならもう1文字削る
  const lastCode = sliced.charCodeAt(sliced.length - 1);
  return lastCode >= 0xd800 && lastCode <= 0xdbff ? sliced.slice(0, -1) : sliced;
};
